import React from "react";
import {
  Box,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";

export default function DialogSkeleton({
  open = true,
  onClose = () => {},
  titleWidth = 200,
  tabCount = 2,
  contentBlocks = [
    { height: 40, width: "60%", sx: { mb: 2 } },
    { height: 120, width: "100%", sx: { mb: 2 } },
    { height: 80, width: "100%" },
  ],
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "16px",
          background: "#F7F7FC",
          borderBottom: "1px solid #E8EAED",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={titleWidth} height={32} />
        </Box>
        <IconButton sx={{ position: "absolute", right: 8, top: 8 }} disabled>
          <Skeleton variant="circular" width={24} height={24} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, minHeight: 300 }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            background: "#FEFEFE",
            px: 3,
            pt: 2,
          }}
        >
          <Tabs value={0} aria-label="Dialog Tabs">
            {[...Array(tabCount)].map((_, idx) => (
              <Tab
                key={idx}
                label={<Skeleton variant="text" width={80 + idx * 40} />}
              />
            ))}
          </Tabs>
        </Box>
        <Box sx={{ p: 3 }}>
          {contentBlocks.map((block, idx) => (
            <Skeleton
              key={idx}
              variant="rectangular"
              height={block.height}
              width={block.width}
              sx={block.sx}
            />
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
